import { Box, Button, ButtonProps, Container, IconButton, Paper, styled, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CreateGroup from "../../Components/CreateGroup";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import variables from "../../../assets/styles/variables.module.scss";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch } from "react-redux";
import ConfirmBase from "../../../Shared-ui/Types/Confirm";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../../Shared-ui/utils/Common/Common";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateModel from "../../Components/CreateModel";
import { Model } from "../../../Shared-ui/Types/Models";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { GET_ALL_MODELS_ADMIN, MODELS, REMOVE_MODEL_ADMIN } from "../../../Services/Endpoint";



const ColorButton = styled(Button)<ButtonProps>(({ }) => ({
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
}));

const AdminModels = () => {
  const dispatch = useDispatch()
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [pagination, setPagination] = useState({ page: 0, pageSize: 10 });
  const [confirmPopupData, setConfirmPopupData] = useState<ConfirmBase>({ show: false })
  const [model, setModel] = React.useState<Model | null>(null);
  const [models, setModels] = React.useState<any[]>([]);
  const prevPage = useRef<number>(pagination.page);
  const [modelCount, setModelCount] = useState(0);

  useEffect(() => {
    getModels()
  }, [])

  useEffect(() => {
    if (prevPage.current !== pagination.page) {
      getModels()
      prevPage.current = pagination.page;
    }
  }, [pagination])


  const getModels = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(`${GET_ALL_MODELS_ADMIN}?page=${pagination.page + 1}&page_size=${pagination.pageSize}`).then((res) => res?.data);
      setModels(data?.items || [])
      setModelCount(data.pagination.total || 0)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };




  const handleEdit = (row: any) => {
    setModel(row)
    setOpen(true)
  };

  const deleteModel = async (rowInfo: any) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading())
      const data = await BaseInstance.put(`${REMOVE_MODEL_ADMIN}/${rowInfo.id}`).then((res) => res?.data);
      data?.is_success && dispatch(ShowSuccess(data?.message));
      // getModels();
      getModels();
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  }

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    getModels();
    setOpen(false)
    setModel(null);
    getModels();
  };

  const handlePaginationMetaChange = (paginationMeta: any) => {
    const { page, pageSize, rowCount } = paginationMeta;
    setPagination({ page: page, pageSize: pageSize })
  };

  const columns: GridColDef[] = [
    {
      field: "provider",
      headerName: "Provider",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "model",
      headerName: "Model",
      flex: 1,
      minWidth: 150,
    }, {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "created_at",
      headerName: "Created",
      width: 150,
      flex: 0.5,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Box>
            {formatDate(params.value)}
          </Box>
        );
      },
    },
    {
      field: "updated_at",
      headerName: "Updated",
      width: 150,
      align: "center",
      flex: 0.5,
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Box>
            {formatDate(params.value || params.row.created_at)}
          </Box>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const handleDeleteClick = (event: React.MouseEvent) => {
          setConfirmPopupData({
            show: true,
            setConfirmPopupData: setConfirmPopupData,
            title: "Confirm Deletion",
            info: "Are you sure want to delete your data? This action cannot be undone.",
            varient: "delete",
            functionName: deleteModel,
            functionParam: params
          })
        };
        return (
          <Box sx={{ display: "flex", gap: 1, marginTop: 1.5, justifyContent: "center", alignItems: "center", width: "100%" }}>
            <Tooltip title="Edit" placement="top-start">
              <IconButton
                size="small"
                onClick={() => handleEdit(params.row)}
                sx={{ "&:hover": { color: "primary.main" } }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete" placement="top-start">
              <IconButton
                size="small"
                onClick={() => handleDeleteClick(params.row)}
                sx={{ "&:hover": { color: "error.main" } }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
    },
  ];

  return (
    <>   <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { md: "flex-end", sm: "flex-start" },
            gap: { md: "10px", sm: "0" },
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <Breadcrumb data={[{ name: "Models", path: "" }]} />
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <ColorButton
            variant="contained"
            disableElevation
            startIcon={<AddIcon />}
            size={isSmallScreen ? "small" : "large"}
            sx={{
              textTransform: "capitalize",
              fontWeight: "400",
              whiteSpace: "nowrap",
              borderRadius: { sm: "8px", xs: "4px" },
              height: "40px",
            }}
            onClick={handleOpen}
          >
            Add Model
          </ColorButton>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            height: "100%",
            gap: 4,
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Paper variant="outlined" sx={{ height: "100%", width: "100%" }}>
              <DataGrid
                rows={models}
                columns={columns}
                pageSizeOptions={[10]}
                rowCount={modelCount}
                initialState={{ pagination: { paginationModel: pagination } }}
                onPaginationModelChange={handlePaginationMetaChange}
                disableColumnResize // Disables resizing
                paginationMode="server"
                disableRowSelectionOnClick
                sx={{
                  border: 0,
                  "& .MuiDataGrid-cell:focus": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-cell:focus-within": {
                    outline: "none",
                  },
                }}
              />
            </Paper>
          </Box>
        </Box>
      </Box>
      <CreateModel open={open} handleClose={handleClose} model={model} />
      <ConfirmPopup details={confirmPopupData} />
    </Container>
    </>
  );
};

export default AdminModels;
